export default __webpack_public_path__ + "static/media/websiteColoring.ef2a1404.gif";